import { render, staticRenderFns } from "./benefits-faq-section.vue?vue&type=template&id=43250487&scoped=true"
import script from "./benefits-faq-section.vue?vue&type=script&lang=js"
export * from "./benefits-faq-section.vue?vue&type=script&lang=js"
import style0 from "./benefits-faq-section.vue?vue&type=style&index=0&id=43250487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43250487",
  null
  
)

export default component.exports